import { atom } from 'jotai';
import { atomFamily, atomWithRefresh } from 'jotai/utils';
import { z } from 'zod';
import { guardedClient } from '../features/auth/api/clients';
import { listAdvisorsResponseSchema, type ListAdvisorsResponse } from '@minutes-system/backend/src/api/advisors/schema';
import fetchAndValidate from '../lib/fetchAndValidate';

// Advisorsキャッシュの無効化トリガー
// この値をインクリメントすると、atomFamilyで生成された全ページのadvisorsQueryAtomが再評価され、APIが再呼び出される
export const advisorsResetAtom = atom(0);

const advisorListParamsSchema = z.object({
  page: z.number().optional(),
  name: z.string(),
  phone: z.string(),
});

// パラメータなし（全件取得）またはpage必須（ページネーション付き検索）
type AdvisorListParams =
  | { page?: never; name?: never; phone?: never }
  | { page: number; name?: string; phone?: string };

export const buildAdvisorsQueryKey = (params: AdvisorListParams): string =>
  JSON.stringify({
    page: params.page,
    name: params.name ?? '',
    phone: params.phone ?? '',
  });

export const advisorsQueryAtom = atomFamily((key: string) =>
  atomWithRefresh<Promise<ListAdvisorsResponse>>(get => {
    get(advisorsResetAtom);
    const params = advisorListParamsSchema.parse(JSON.parse(key));

    if (params.page === undefined) {
      return fetchAndValidate(
        guardedClient.advisors.$get({ query: {} }) as Promise<Response>,
        listAdvisorsResponseSchema
      );
    }

    const query: { page: string; name?: string; phone?: string } = {
      page: String(params.page),
    };
    if (params.name) {
      query.name = params.name;
    }
    if (params.phone) {
      query.phone = params.phone;
    }

    return fetchAndValidate(guardedClient.advisors.$get({ query }) as Promise<Response>, listAdvisorsResponseSchema);
  })
);
